import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaPaperPlane, FaClock, FaWhatsapp } from 'react-icons/fa';
import './ContactPage.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [result, setResult] = React.useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('Form submitted:', formData);
  //   alert('Thank you for your inquiry! We will get back to you soon.');
  //   setFormData({
  //     name: '',
  //     email: '',
  //     phone: '',
  //     service: '',
  //     message: ''
  //   });
  // };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "c0655fa5-618e-4ec2-904b-9ba99805d40c");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  const contactInfo = [
    {
      icon: <FaPhone />,
      title: 'Phone',
      details: ['+91 95604 24647', '+91 78387 01636'],
      link: 'tel:+919560424647'
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      details: ['omshaktigoodservices@gmail.com'],
      link: 'mailto:omshaktigoodservices@gmail.com'
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Address',
      details: [`PLOT IN KH. 25/12/2, 13, 14, 15 SEQ NO.S-P-61, G/F, GALI NO.1,
SALAHPUR KHERA BIJWASAN, NEW DELHI-110061`],
      link: '#'
    },
    {
      icon: <FaClock />,
      title: 'Working Hours',
      details: ['Monday - Friday: 9:00 AM - 6:00 PM', 'Saturday: 9:00 AM - 4:00 PM', 'Sunday: Closed'],
      link: '#'
    }
  ];

  return (
    <div className="contact-page">
      {/* Page Hero */}
      <section className="page-hero contact-hero">
        <Container>
          <Row>
            <Col lg={12} className="text-center">
              <span className="page-badge">Contact Us</span>
              <h1 className="page-title">Get In Touch With Us</h1>
              <p className="page-description">
                Have a question or want to discuss your project? We're here to help. 
                Fill out the form below or reach out to us directly.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Info Cards */}
      <section className="contact-info-section">
        <Container>
          <Row className="g-4">
            {contactInfo.map((info, index) => (
              <Col key={index} lg={3} md={6}>
                <Card className="contact-info-card-page">
                  <Card.Body className="text-center p-4">
                    <div className="contact-icon-page">{info.icon}</div>
                    <Card.Title className="contact-info-title">{info.title}</Card.Title>
                    {info.details.map((detail, idx) => (
                      <Card.Text key={idx} className="contact-info-text">
                        {detail}
                      </Card.Text>
                    ))}
                    {info.link !== '#' && (
                      <a href={info.link} className="contact-link">
                        {info.title === 'Phone' ? 'Call Now' : info.title === 'Email' ? 'Send Email' : 'View Map'}
                      </a>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto">
              <Card className="contact-form-card-page">
                <Card.Body className="p-5">
                  <div className="text-center mb-4">
                    <h2 className="form-title">Send Us a Message</h2>
                    <p className="form-subtitle">
                      Fill out the form below and we'll get back to you as soon as possible
                    </p>
                  </div>
                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group controlId="formName">
                          <Form.Label>Your Name *</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter your full name"
                            required
                            className="form-control-custom"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="formEmail">
                          <Form.Label>Email Address *</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            required
                            className="form-control-custom"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="formPhone">
                          <Form.Label>Phone Number *</Form.Label>
                          <Form.Control
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Enter your phone number"
                            required
                            className="form-control-custom"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="formService">
                          <Form.Label>Service Interested In</Form.Label>
                          <Form.Select
                            name="service"
                            value={formData.service}
                            onChange={handleChange}
                            className="form-control-custom"
                          >
                            <option value="">Select a service</option>
                            <option value="marble-polishing">Marble Polishing</option>
                            <option value="granite-polishing">Granite Polishing</option>
                            <option value="Marble-Floor-Polishing">Marble Floor Polishing</option>
                            <option value="floor-cleaning">Floor Cleaning</option>
                            <option value="facade-glass-cleaning">Facade Glass Cleaning</option>
                            <option value="Floor-Scrubbing">Floor Scrubbing</option>
                             <option value="Marble-Tiles">Marble Tiles</option>
                            <option value="wall-painting">Wall Painting</option>
                            <option value="House-Painting">House Painting</option>
                             <option value="Wooden-Melamine">Wooden Melamine</option>
                              <option value="Home-Construction">Home Construction</option>
                              <option value="Carpet-Shampooing">Carpet Shampooing</option>
                              <option value="Office-and-House-Renovation">Office and House Renovation</option>
                            <option value="Stone-Polishing">Stone Polishing</option>
                            <option value="Paint-Work">Paint Work</option>
                            <option value="Manpower-Supply">Manpower Supply</option>
                            <option value="Deep-Cleaning">Deep Cleaning</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group controlId="formMessage">
                          <Form.Label>Message *</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={6}
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Tell us about your project requirements..."
                            required
                            className="form-control-custom"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} className="text-center">
                        <Button variant="primary" type="submit" size="lg" className="submit-button-page">
                          <FaPaperPlane className="me-2" />
                          Send Message
                        </Button>
                      </Col>
                      <Col md={12}>
                        <span className='text-success'>{result}</span>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <Container fluid className="p-0">
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d219.11715033743883!2d77.065823!3d28.5134262!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d197cedbd8c7d%3A0x1e6c131f3f31b87b!2sGali%20Number%201%2C%20Palam%20Farms%2C%20Delhi%2C%20110061!5e0!3m2!1sen!2sin!4v1762587727690!5m2!1sen!2sin" style={{width:"100%", height:"450px"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          {/* <div className="map-placeholder">
            <FaMapMarkerAlt className="map-icon" />
            <p>Map Location</p>
            <small>Add your Google Maps embed here</small>
          </div> */}
        </Container>
      </section>

      {/* WhatsApp CTA */}
      <section className="whatsapp-cta">
        <Container>
          <Row>
            <Col lg={12} className="text-center">
              <Card className="whatsapp-card">
                <Card.Body className="p-4">
                  <FaWhatsapp className="whatsapp-icon" />
                  <h4>Need Immediate Assistance?</h4>
                  <p>Chat with us on WhatsApp for instant support</p>
                  <Button href="https://wa.me/919560424647" target="_blank" variant="success" size="lg">
                    <FaWhatsapp className="me-2" />
                    Chat on WhatsApp
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Contact;



